import React from "react";

export const ConsolidationDetailContext = React.createContext(null);

export const useConsolidationDetailContext = () => {
    const context = React.useContext(ConsolidationDetailContext);

    if (!context) throw new Error("Consolidation Detail Context not provided!");

    return context;
};